import { getStyleProp } from './css-property-utils';
export const inlineFontSize = (element, fallbacks) => {
    const elementClasses = element.attr('class');
    if (elementClasses && elementClasses.includes('so-global')) {
        return element;
    }
    const fontSize = getStyleProp(element, 'font-size', fallbacks.css) || fallbacks.fontSize;
    return element.css('font-size', `${parseInt(fontSize, 10)}px`);
};
//# sourceMappingURL=inline-font-size.js.map